import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import useGetFacilities from "../../../hooks/api/useGetFacilities";
import {Facility} from "../../../types/Facility";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";

// Types ----

type FacilitiesPanelProps = {
  onSelect: (facility: Facility) => void;
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
  isMultiSite?: boolean
}

// Component ----

function FacilitiesPanel({ onSelect, selectedItems, siteId, isMaxSelected, isMultiSite }: FacilitiesPanelProps) {
  const {data: facilities, isLoading} = useGetFacilities({
    sites: siteId?.toString(),
    per_page: 1000,
    published: true,
  }, false);

  return (
    <PanelWrapper isLoading={isLoading}>
      {isLoading ?
        loadingSkeleton :
        <>
          {!!facilities?.data?.length ? facilities?.data.map(facility => {
              const selected = isSelected(facility, ENTITY_TYPES.FACILITY, selectedItems);

              return (
                <Card
                  key={facility.id}
                  onClick={() => onSelect(facility)}
                  heading={facility.name}
                  subheading={facility.description ?? ''}
                  footer={isMultiSite ? facility.zone.site.name : null}
                  imageUrl={facility.image?.preview_url}
                  active={selected}
                  disabled={isMaxSelected && !selected}
                />
              )
            }) :
            <EmptyState />
          }
        </>
      }
    </PanelWrapper>
  );
}

export {FacilitiesPanel};